import createAction from "redux-actions/es/createAction";
import { getQuintessitalData as api } from "../api/index";
import { getTriageData as triageDataApi } from "../api/index";
import { createTicket as createTicketApi } from "../api/index";
import { fetchJobId as fetchJobIdApi } from "../api/index";
import { toastr } from "react-redux-toastr";
import { getProjectCollections , getSuitTypes , getDates , getReport } from '../../autoation-analytics/actions/index';
import {fetchSuiteForQt as fetchSuiteForQtApi} from '../api/index';
import {fetchQt as fetchQtApi} from '../api/index';

export const quintessital = createAction("QUINTESSENTIAL_START");
export const quintessitalFail = createAction("QUINTESSENTIAL_FAIL");
export const quintessitalSuccess = createAction("QUINTESSENTIAL_SUCCESS");
export const quintessitalClear = createAction("QUINTESSENTIAL_CLEAR");

// fetchJobId

export const getJobId = createAction("JOB_ID_START");
export const getJobIdFail = createAction("JOB_ID_FAIL");
export const getJobIdSuccess = createAction("JOB_ID_SUCCESS");
export const getJobIdClear = createAction("JOB_ID_CLEAR");


export const triageData = createAction("TRIAGE_DATA_START");
export const triageDataFail = createAction("TRIAGE_DATA_FAIL");
export const triageDataSuccess = createAction("TRIAGE_DATA_SUCCESS");

export const suiteQtData = createAction("SUITE_QT_DATA_START");
export const suiteQtDataFail = createAction("SUITE_QT_DATA_FAIL");
export const suiteQtDataSuccess = createAction("SUITE_QT_DATA_SUCCESS");


export const suiteQtRunIdData = createAction("SUITE_QT_RUN_ID_DATA_START");
export const suiteQtRunIdDataFail = createAction("SUITE_QT_RUN_ID_DATA_FAIL");
export const suiteQtRunIdDataSuccess = createAction("SUITE_QT_RUN_ID_DATA_SUCCESS");

export const fetchProjects = () => {
  return  async (dispatch) => {
    await dispatch(getProjectCollections())
  }
};

export const fetchSuiteType = (val,project) => {
  return  async (dispatch) => {
    await dispatch(getSuitTypes(val))
  }
};
export const fetchReport = (value , project, type) => {
  return  async (dispatch) => {
    await dispatch(getReport(value , project, type))
  }
};
export const fetchDates = (val, project) => {
  return  async (dispatch) => {
    await dispatch(getDates(val, project))
  }
};

export const getQuintessital =  (data, project) => {
  return async (dispatch) => {
    await api(data, project)
      .then((res) => {
          dispatch(quintessitalSuccess(res.data));
          dispatch( getTriageData(data, project));
      })
      .catch((err) => {
        let errorMessage=`There is no data found with this runId:${data?.runId}`
        let m=err.message;
        if(m.includes('status code 412')){
          toastr.error('Error', errorMessage);
          dispatch(quintessitalSuccess([]));
          dispatch(triageDataSuccess([]));
        }
        dispatch(quintessitalFail(err));
      });
  };
};
export const fetchSuiteForQt =  (database, project) => {
  return async (dispatch) => {
    await fetchSuiteForQtApi(database, project)
      .then((res) => {
          if(res.data.length===0){
            toastr.error('Error', `Unable to find data of ${project} project`);
            dispatch(suiteQtDataSuccess(res.data));
          }else{
            dispatch(suiteQtDataSuccess(res.data));
          }
      })
      .catch((err) => {
        dispatch(suiteQtDataFail(err));
      });
  };
};
export const fetchQt =  ( project,data) => {
  return async (dispatch) => {
    await fetchQtApi(project,data)
      .then((res) => {
          dispatch(suiteQtRunIdDataSuccess(res.data));
          let  dataCk = {
            suiteType: data.subCategory,
            runId: res.data.runId,
          };
          dispatch(getQuintessital(dataCk, project));
          // dispatch(getTriageData(dataCk, project));

      })
      .catch((err) => {
        dispatch(suiteQtRunIdDataFail(err));
      });
  };
};
export const getTriageData =  (data, project) => {
  return async (dispatch) => {
    await triageDataApi(data, project)
      .then((res) => {
          dispatch(triageDataSuccess(res.data));
      })
      .catch((err) => {
        dispatch(triageDataSuccess([]));
        dispatch(triageDataFail(err));
      });
  };
};


export const createTicket =  (data, project) => {
  return async (dispatch) => {
    await createTicketApi(data, project)
      .then((res) => {
        //  if(res?.data?.jiraUpdateStatus==='success'){
        //    let temData = {
        //     suiteType:'smoke',
        //     runId:'1610184435000'
        //   }
        //   getQuintessital(temData, 'clm');
        //  }
         toastr.success('Ticket Added', res?.data?.AnalyticsUpdateData);
      
      })
      .catch((err) => {
        dispatch(quintessitalFail(err));
      });
  };
};

export const fetchJobId =  (data) => {
  return async (dispatch) => {
    await fetchJobIdApi(data)
      .then((res) => {
        dispatch(getJobIdSuccess(res.data));
      })
      .catch((err) => {
        dispatch(quintessitalFail(err));
      });
  };
};


